import { Box, Button, Fade } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { filterState } from "../context/states";
import AutocompleteStyled from "./AutocompleteStyled";

export const RegionSelector = ({
  name = "region",
  onChange,
  regions,
  variant,
  label,
  placeholder,
  value,
}) => {
  const [fatherRegion, setFatherRegion] = useState(null);
  const [region, setRegion] = useState(null);
  const [options, setOptions] = useState(regions.filter((r) => !r.father));
  const filter = useRecoilValue(filterState);

  useEffect(() => {
    if (value) {
      const selectedRegion = regions.find((r) => r.id + "" === value + "");
      if (selectedRegion) {
        setFatherRegion(selectedRegion);
        setRegion(selectedRegion);
      }
    }
  }, [value, regions]);

  useEffect(() => {
    if (!fatherRegion) {
      setOptions(regions.filter((r) => !r.father));
      return;
    }

    setOptions(regions.filter((r) => r.father?.id === fatherRegion?.id));
  }, [fatherRegion]);

  useEffect(() => {
    if (!filter.region) {
      setFatherRegion(null);
      setRegion(null);
    }
  }, [filter?.region]);

  const handleSelected = (event, selectedRegion) => {
    event.target.name = name;
    event.target.value = selectedRegion?.id;

    setFatherRegion(selectedRegion);
    setRegion(selectedRegion);

    if (onChange) {
      onChange(event, selectedRegion);
    }
  };

  const changeToFather = (event) => {
    event.target.name = name;
    event.target.value = fatherRegion?.father;

    setFatherRegion(fatherRegion?.father);
    setRegion(fatherRegion?.father);

    if (onChange) {
      onChange(event, fatherRegion?.father);
    }
  };

  const PaperComponentRegionSelector = ({
    props,
    ref,
    containerProps,
    children,
  }) => {
    return (
      <Paper {...containerProps}>
        {regions?.length === 0 ? (
          <></>
        ) : (
          <>
            <Fade in>
              <Box ref={ref} {...props}>
                {children}
              </Box>
            </Fade>
            <Button fullWidth variant="contained" color="secondary">
              {fatherRegion?.name?.length > 0 ? (
                <>{fatherRegion.name} auswählen</>
              ) : (
                "Alle Regionen (NRW) auswählen"
              )}
            </Button>
          </>
        )}
      </Paper>
    );
  };

  return (
    <>
      <AutocompleteStyled
        name={name}
        variant={variant}
        label={label}
        options={options}
        value={region}
        placeholder={placeholder}
        onChange={handleSelected}
        fatherRegion={fatherRegion}
        changeToFather={changeToFather}
        isOptionEqualToValue={(option, value) =>
          option.id === (value?.id ?? value)
        }
        getOptionLabel={(option) => `${option.name}`}
        disableCloseOnSelect={true}
        PaperComponent={PaperComponentRegionSelector}
      />
    </>
  );
};
